import styled from "styled-components";
import Button from "@/atoms/Button";
import Icon from "@/atoms/Icon";
import cx from "classnames";

const StatusIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1rem;
  color: #086e6a;
  margin-right: 0.75rem;
  svg {
    position: absolute;
  }

  .disconnect {
    visibility: hidden;
  }
`;

const CustomButton = styled(Button)`
  color: #5e5e5e;
  &.secondary {
    border-color: rgba(36, 34, 38, 0.15) !important;
  }
  height: 40px;
  font-size: 14px;
  max-width: 260px;

  &.connected {
    border-color: transparent !important;
    &:hover {
      border-color: ${({ theme }) => theme.colors["error"]} !important;

      ${StatusIcon} {
        color: red;
        .disconnect {
          visibility: visible;
        }
        .connected {
          visibility: hidden;
        }
      }
    }
  }
`;

const ConnectAccountButton = ({
  connected,
  onDisconnect,
  renderConnectButton,
  type,
  ...props
}) => {
  const label = (
    <div className={"flex items-center justify-center"}>
      {connected && (
        <StatusIcon>
          <Icon name={"checkmark"} size={"1rem"} className={"connected"} />
          <Icon name={"times"} size={"1rem"} className={"disconnect"} />
        </StatusIcon>
      )}
      <Icon name={type.toLowerCase()} size={"1rem"} className={"mr-3"} />
      {connected ? "Connected" : "Connect"} to {type}
    </div>
  );

  return connected ? (
    <CustomButton
      label={label}
      className={cx({ connected })}
      level={"secondary"}
      onClick={onDisconnect}
      {...props}
    />
  ) : (
    renderConnectButton()
  );
};

export default ConnectAccountButton;
